import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@e2n/ui';
import { useTranslation } from 'react-i18next';
import { useTerminDeleteHandler } from '@/domain/termine/hooks/useTerminDeleteHandler';
import { Termin } from '@/domain/termine/shared/types';

type TerminDeleteDialogProps = {
  termin: Termin;
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

export function TerminDeleteDialog({
  termin,
  open,
  onOpenChange,
}: TerminDeleteDialogProps) {
  const { t } = useTranslation();
  const { handleDelete, loading } = useTerminDeleteHandler(termin);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="top-3/12 translate-y-0 p-4">
        <DialogHeader className="*:text-neutrals-900 px-4">
          <DialogTitle className="py-4 text-xl">
            {t('domain.termine.deleteDialog.deleteTermin')}
          </DialogTitle>
          <DialogDescription>
            {t('domain.termine.deleteDialog.deleteTerminDescription')}
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-row gap-4 w-full justify-end pt-8">
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            {t('domain.termine.deleteDialog.cancel')}
          </Button>
          <Button
            variant="destructive"
            disabled={loading}
            onClick={async () => {
              await handleDelete();
              onOpenChange(false);
            }}>
            {t('domain.termine.deleteDialog.delete')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
